import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IAuthorResponse } from 'src/app/core/models/i-author-response';
import { UpdateAuthorResponse } from 'src/app/core/models/i-update-author-response';
import { SaveAuthorResponse } from '../../core/models/i-save-author-response';
import { SaveAuthorRequest } from '../../core/models/i-save-author-request';
import { RestService } from './rest-service';
import { IAuthor } from 'src/app/core/models/i-author';

@Injectable({
  providedIn: 'root',
})
export class AuthorService {
  static readonly ENTITY_IDENTIFIER: string = 'authors';
  private readonly BASE_AUTHORS_ROUTE = `api/${AuthorService.ENTITY_IDENTIFIER}`;
  private readonly BUILD_HTTP_ROUTE = (...args) =>
    this.restService.BUILD_HTTP_ROUTE(this.BASE_AUTHORS_ROUTE, ...args);

  constructor(private restService: RestService) {}

  getFilteredBySearchText$(searchText: string): Observable<IAuthorResponse> {
    const params = this.restService.buildHttpParamsObject({
      searchText: searchText.trim(),
    });
    return this.restService.get$<IAuthorResponse>(this.BUILD_HTTP_ROUTE(), {
      params,
    });
  }

  getPagedFilteredBySearchText$(
    searchText: string,
    pageNumber: number,
    pageSize: number,
  ): Observable<IAuthorResponse> {
    const params = this.restService.buildParamsObjectWithPaging(
      {
        searchText: searchText.trim(),
      },
      pageNumber,
      pageSize,
    );
    return this.restService.get$<IAuthorResponse>(this.BUILD_HTTP_ROUTE(), {
      params,
    });
  }

  getById$(searchText: string): Observable<IAuthor> {
    return this.restService.get$<IAuthor>(this.BUILD_HTTP_ROUTE(searchText));
  }

  create$(
    nameText: string,
    locationText: string,
  ): Observable<SaveAuthorResponse> {
    const request = new SaveAuthorRequest(nameText, locationText);
    return this.restService.post$<SaveAuthorResponse>(
      this.BUILD_HTTP_ROUTE(),
      request,
    );
  }

  update$(
    idText: string,
    nameText: string,
    locationText: string,
  ): Observable<UpdateAuthorResponse> {
    const request = new SaveAuthorRequest(nameText, locationText);
    return this.restService.put$<UpdateAuthorResponse>(
      this.BUILD_HTTP_ROUTE(idText),
      request,
    );
  }
}
